<template>
  <ModalDialog v-model="isShow" :level="level || 9">
    <div class="p-5 field-of-fields" slot="dialog-content">
      <h2 v-if="title">{{ title }}</h2>
      <h4 class="description" v-if="description">{{ description }}</h4>
      <hr v-if="title" :style="hasDistanceTop ? null : 'margin-bottom: 0'" />
      <FormGroupRowLayout
        :listFields="listFields"
        :modelData="applicationData"
        :submitInfo="{
          type: dialogId,
        }"
        :submitClicked="submitClicked"
      />
      <hr />
      <div class="button-group">
        <button
          type="button"
          class="mylisting-button secondary-button cancel-button"
          @click="hideModal()"
        >
          {{ cancelLabel }}
        </button>
        <button
          v-if="hasDeleteBtn"
          type="button"
          class="mylisting-button danger-button"
          @click="handleClickDeleteBtn()"
        >
          {{ deleteLabel }}
        </button>

        <button
          type="button"
          class="mylisting-button dark-button"
          style="float: right"
          :disabled="isRecordingVideo"
          @click="handleSubmit()"
        >
          {{ submitLabel }}
        </button>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
/* This component is used to show input dialog.
To show an input dialog, call this.showInputDialog(inputObject)
Structure of inputObject:
{
    title: 'String',
    listFields: 'Array',
    data: 'Object', // Initial data
    submitLabel: 'String', <- This field is optional, if not set, use default: Submit
    cancelLabel: 'String' <- This field is optional, if not set, use default: Cancel
    onSubmitCallback: function reference <- This field is optional, if set, the function will be called after close dialog
}

*/

import ModalDialog from "./ModalDialog";
import { mapGetters } from "vuex";

export default {
  name: "InputDialog",
  data: function () {
    return {
      title: "",
      description: "",
      onSubmitCallback: null,
      onCloseCallback: null,
      listFields: [],
      applicationData: {},
      isShow: false,
      submitLabel: "Submit",
      cancelLabel: "Cancel",
      deleteLabel: "Delete",
      submitClicked: false,
      hasDistanceTop: false,
      keepDialogOnSubmit: false,
      hasDeleteBtn: false,
      confirmDeleteKey: "",
      onDeleteCallback: null,
      level: null,
    };
  },
  components: {
    ModalDialog,
  },
  computed: {
    ...mapGetters(["isRecordingVideo", "agencyID", "userID"]),
    dialogId() {
      return `input_dialog_${this.agencyID}_${this.userID}`;
    },
  },
  methods: {
    hideModal() {
      if (this.onCloseCallback) {
        this.onCloseCallback();
      }
      this.isShow = false;
      this.hideInputDialog();
    },
    handleSubmit() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.applicationData, this.listFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        return;
      } else {
        if (this.onSubmitCallback) {
          this.onSubmitCallback(this.applicationData);
        }
        if (!this.keepDialogOnSubmit) {
          this.isShow = false;
          this.showInputDialog(null);
        }
      }
    },
    handleClickDeleteBtn() {
      this.showConfirmDialog({
        key: this.confirmDeleteKey,
        onAcceptCallback: () => {
          if (this.onDeleteCallback) {
            this.onDeleteCallback();
            this.hideModal();
          }
        },
      });
    },
  },
  created() {
    this.$store.watch(
      (state) => state.dialogs.inputDialog,
      (value) => {
        if (!value) {
          this.isShow = false;
          this.showInputDialog(null);
        } else {
          if (this.isShow) {
            return;
          }
          this.title = value.title;
          this.message = value.message;
          this.description = value.description;
          this.listFields = value.listFields;
          if (value.data) {
            this.applicationData = value.data;
          } else {
            this.applicationData = {};
          }
          if (!value.submitLabel) {
            this.submitLabel = this.getLabelByKeys("BUTTONS.SUBMIT");
          } else {
            this.submitLabel = value.submitLabel;
          }
          if (!value.cancelLabel) {
            this.cancelLabel = this.getLabelByKeys("BUTTONS.CANCEL");
          } else {
            this.cancelLabel = value.cancelLabel;
          }
          this.onSubmitCallback = value.onSubmitCallback;
          this.onCloseCallback = value.onCloseCallback;
          this.hasDistanceTop = value.hasDistanceTop;
          this.keepDialogOnSubmit = value.keepDialogOnSubmit;
          this.level = value.level;
          this.hasDeleteBtn = value.hasDeleteBtn;
          if (this.hasDeleteBtn) {
            if (!value.deleteLabel) {
              this.deleteLabel = this.getLabelByKeys("BUTTONS.DELETE");
            } else {
              this.deleteLabel = value.deleteLabel;
            }
            this.confirmDeleteKey = value.confirmDeleteKey;
            this.onDeleteCallback = value.onDeleteCallback;
          }
          this.submitClicked = false;
          this.isShow = true;
        }
      },
      { immediate: true }
    );
  },
  watch: {
    isShow: {
      immediate: true,
      handler() {
        if (!this.isShow) {
          this.hideModal();
        }
      },
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  h2 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/global-dialogs/InputDialog.vue